import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { useLanguage } from '../../../../contexts/LanguageContext';

const CariDetailReportFilters = ({
    filters,
    onApplyFilters,
    onReset,
    customerDropdown
}) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(true);

    const [localFilters, setLocalFilters] = useState({
        startDate: filters.startDate,
        endDate: filters.endDate,
        typeOfMovement: filters.typeOfMovement ?? null
    });

    useEffect(() => {
        setLocalFilters({
            startDate: filters.startDate,
            endDate: filters.endDate,
            typeOfMovement: filters.typeOfMovement ?? null
        });
    }, [filters.startDate, filters.endDate, filters.typeOfMovement]);

    const moveTypeOptions = [
        { label: th('currentAccountReport.debit') || 'Borç', value: 1 },
        { label: th('currentAccountReport.credit') || 'Alacak', value: 2 },
    ];

    const toggleOpen = () => setFilterOpen((prev) => !prev);

    const handleStartDateChange = (e) => {
        setLocalFilters(prev => ({ ...prev, startDate: e.value }));
    };

    const handleEndDateChange = (e) => {
        setLocalFilters(prev => ({ ...prev, endDate: e.value }));
    };

    const handleApply = () => {
        onApplyFilters(localFilters);
    };

    const handleReset = () => {
        onReset();
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button
                        icon="pi pi-filter"
                        label={th('common.filter') || 'Filtrele'}
                        onClick={toggleOpen}
                        outlined={!filterOpen}
                    />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">
                        {th('filter.advancedFilters') || 'Filtreler'}
                    </div>

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('cariDetailReport.startDate') || 'Başlangıç Tarihi'}
                                </label>
                                <Calendar
                                    id="startDate"
                                    value={localFilters.startDate}
                                    onChange={handleStartDateChange}
                                    dateFormat="dd.mm.yy"
                                    showIcon
                                    className="w-full"
                                    maxDate={localFilters.endDate}
                                    placeholder={th('common.selectDate') || 'Tarih seçin'}
                                />
                            </div>
                        </div>

                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('cariDetailReport.endDate') || 'Bitiş Tarihi'}
                                </label>
                                <Calendar
                                    id="endDate"
                                    value={localFilters.endDate}
                                    onChange={handleEndDateChange}
                                    dateFormat="dd.mm.yy"
                                    showIcon
                                    className="w-full"
                                    minDate={localFilters.startDate}
                                    placeholder={th('common.selectDate') || 'Tarih seçin'}
                                />
                            </div>
                        </div>

                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">
                                    {th('cariDetailReport.moveType') || 'Hareket Tipi'}
                                </label>
                                <Dropdown
                                    id="typeOfMovement"
                                    value={localFilters.typeOfMovement}
                                    onChange={(e) => setLocalFilters(prev => ({ ...prev, typeOfMovement: e.value }))}
                                    options={moveTypeOptions}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder={th('cariDetailReport.moveType') || 'Hareket Tipi'}
                                    className="w-full"
                                    showClear
                                />
                            </div>
                        </div>

                        <div className="flex-auto" style={{ minWidth: 200, maxWidth: 280 }}>
                            <div className="field mb-2 p-1">
                                <label htmlFor="reportCustomer" className="block mb-1 text-sm">
                                    {th('preAccounting.customer') || 'Müşteri'}
                                </label>
                                <Dropdown
                                    key={customerDropdown.key}
                                    id="reportCustomer"
                                    value={customerDropdown.value}
                                    onChange={(e) => customerDropdown.onChange(e.value)}
                                    options={customerDropdown.options}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder={customerDropdown.placeholder}
                                    className="w-full"
                                    filter
                                    filterTemplate={customerDropdown.filterTemplate}
                                    showClear
                                    loading={customerDropdown.loading}
                                    appendTo="self"
                                    emptyMessage={customerDropdown.emptyMessage}
                                    onShow={customerDropdown.onShow}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3 gap-2">
                        <Button
                            label={th('filter.reset') || 'Sıfırla'}
                            icon="pi pi-refresh"
                            className="p-button-outlined"
                            onClick={handleReset}
                        />
                        <Button
                            label={th('cariDetailReport.search') || 'Ara'}
                            icon="pi pi-search"
                            onClick={handleApply}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CariDetailReportFilters;
